import { FC } from 'react';

interface TrendingHashtagsProps {
  hashtags: string[];
}

const TrendingHashtags: FC<TrendingHashtagsProps> = ({ hashtags }) => {
  return (
    <div className="w-full bg-gray-50 dark:bg-gray-900 rounded-lg py-2 relative">
      {/* Mask gradients only shown on mobile */}
      <div className="absolute left-0 top-0 bottom-0 w-6 bg-gradient-to-r from-gray-50 to-transparent dark:from-gray-900 z-10 pointer-events-none lg:hidden"></div>
      <div className="absolute right-0 top-0 bottom-0 w-6 bg-gradient-to-l from-gray-50 to-transparent dark:from-gray-900 z-10 pointer-events-none lg:hidden"></div>
      
      {/* Container: scrollable on mobile, flex-wrap on desktop */}
      <div className="w-full px-4 pb-1 overflow-x-auto scrollbar-hide lg:overflow-visible">
        <div className="flex space-x-3 whitespace-nowrap min-w-min lg:flex-wrap lg:whitespace-normal lg:space-x-0 lg:gap-3">
          {hashtags.map((tag, index) => (
            <a 
              key={index} 
              href={`/search?q=${tag}`}
              className="inline-flex items-center justify-center px-3 py-1.5 bg-white dark:bg-gray-800 rounded-lg text-sm font-medium text-[#ffc11f] dark:text-[#ffc11f] border border-[#ffc11f] dark:border-[#ffc11f] hover:bg-[#065900] hover:text-white dark:hover:bg-[#065900] dark:hover:text-white transition-colors flex-shrink-0 lg:flex-shrink lg:mb-2"
              data-component-name="TrendingHashtags"
            >
              #{tag}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrendingHashtags;
